<template>
	<div>
		<v-card-title>
			<h2>Lista projektów oferenta {{bidderName}}</h2>
		</v-card-title>
		<ProjectTable/>
	</div>
</template>

<script>
	import ProjectTable from "./components/ProjectTable";
	import {Bidder} from "@/api/generated/Bidder";

	export default {
		name: "BidderProjectsView",
		components: {
			ProjectTable
		},

		data () {
			return {
				bidderName: "",
			};
		},

		created () {
			if (this.$route.params.bidderId) { // subbider logged
				Bidder.getPolishName(this, this.$route.params.bidderId, successResponse => {
						this.bidderName = successResponse.name;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się pobrać nazwy oferenta", errorResponse);
					});
			}
		}
	};
</script>

<style scoped>

</style>
